/**
 * InlineError Component
 * Displays an error message inline with optional retry functionality
 * Used for non-blocking error states within sections/cards
 */

import React from 'react';

const InlineError = ({
  message = 'Something went wrong',
  onRetry = null,
  compact = false,
  className = ''
}) => {
  return (
    <div
      className={`
        flex items-center justify-between gap-3
        p-3 bg-red-50 border border-red-200 rounded-lg
        ${compact ? 'text-sm' : ''}
        ${className}
      `}
    >
      <div className="flex items-center gap-2 text-red-700 min-w-0">
        <svg
          className={`flex-shrink-0 ${compact ? 'w-4 h-4' : 'w-5 h-5'}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span className="truncate">{message}</span>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className={`
            flex-shrink-0 font-medium text-red-700
            hover:text-red-800 hover:bg-red-100
            rounded px-3 py-1.5 transition-colors
            min-h-[36px] touch-manipulation
            ${compact ? 'text-xs' : 'text-sm'}
          `}
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default InlineError;
